import { useState, useParams, FaPencilAlt, FaTrash, FaEye, ToastContainer } from '../../common/common';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Button from 'react-bootstrap/Button';
import { Modal, Form } from "react-bootstrap";
import MidWarehouse from '../../middleware/Settings/MidWarehouse';
import { FaWarehouse } from "react-icons/fa"; // Import the warehouse icon


const Warehouses = () => {
    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, userPlan, warehouse, showEditModal, showDeleteModal, handleCloseEditModal, handleShowEditModal, handleCloseDeleteModal, handleShowDeleteModal, warehouseDetails, handleChange, handleDelete, handleSaveChanges, showAddModal, setShowAddModal, handleCloseAddModal, handleShowAddModal, handlesubmit, handleActiveChange } = MidWarehouse(type);

    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var ActiveUser = users[0]["Status"];
    }
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }
    // console.log({warehouse:warehouse});
    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="w-full ">
                    <div className="col-start-1 col-end-13">
                        <div className=" p-2 text-xl text-[#1e3a8a]">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'> Product Warehouses</h1>
                                <p className=' text-gray-600 text-[16px] '>A product category is a group of similar type of products. Ex. Menswear,Womenswear,Childrenswear</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fixed border-0 flex-row rounded-xl m-3 p-4 ">

                    <div className='flex flex-col lg:flex-row justify-between items-center mb-4'>
                        <h5 className=" capitalize text-xl font-bold mb-0">Warehouses</h5>

                        {ActiveUser === 1 &&
                            <button type="submit" className="relative rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[200px]" onClick={handleShowAddModal}>
                                <span className="relative text-md text-black font-semibold pl-0" >Add Warehouse</span>
                                <div className="lg:flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl hidden lg:block py-3 ">
                                    <FaEye className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                </div>
                            </button>
                        }


                    </div>

                    <div className="">
                        <div className="grid gap-2.5">
                            {warehouse?.map((warehouse, index) => (
                                
                                <div className="flex items-center justify-between flex-wrap group border border-gray-200 rounded-xl gap-2 px-3.5 py-2 bg-[#ededed]">
                                    <div className="flex items-center gap-3">
                                        {/* Warehouse Icon in a Circle */}
                                        <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full">
                                            <FaWarehouse className="text-gray-500 text-xl" />
                                        </div>

                                        <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-2">
                                                <span className="text-gray-900 text-lg font-semibold">
                                                    {warehouse.name}
                                                </span>
                                                {/* Active/Inactive Badge */}
                                                <span
                                                    className={`text-sm font-medium px-2 py-1 rounded-full ${warehouse.status === 1
                                                        ? "bg-green-100 text-green-800" // Active styles
                                                        : "bg-red-100 text-red-800" // Inactive styles
                                                        }`}
                                                >
                                                    {warehouse.status === 1 ? "Active" : "Inactive"}
                                                </span>
                                            </div>
                                            <span className="text-gray-600 text-sm font-medium">
                                                {warehouse.warehouse_address}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="flex flex-row gap-2">
                                        {ActiveUser === 1 &&
                                            <Button
                                                variant="primary"
                                                onClick={(e) => handleShowEditModal(warehouse.id)}
                                                className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#cbd7fa] !text-black !border-[#b9ccff] rounded-full w-10 flex items-center justify-center"
                                            >
                                                <FaPencilAlt className='text-[#193b99]' />
                                            </Button>
                                        }

                                        {ActiveUser === 1 &&

                                            <Button
                                                variant="primary"
                                                onClick={(e) => handleShowDeleteModal(warehouse.id)}
                                                className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#ffd7d7] !text-white !border-[#ffd7d7] rounded-full w-10 flex items-center justify-center"
                                            >
                                                <FaTrash className='text-red-700' />
                                            </Button>
                                        }

                                    </div>
                                </div>

                            ))}
                        </div>
                        {/* Add Modal */}
                        <Modal size="lg" show={showAddModal} onHide={handleCloseAddModal} aria-labelledby="example-modal-sizes-title-lg">
                            <Modal.Body>
                                <div className="relative border-b border-slate-200/60 py-2">
                                    <label className="text-lg">Add New Warehouse</label>
                                    <div
                                        className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer"
                                        onClick={() => handleCloseAddModal()}
                                    >
                                        ESC / Close
                                    </div>
                                </div>
                                <Form>
                                    {/* Title Input */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="title"
                                            value={warehouse.title}
                                            onChange={handleChange}
                                            placeholder="Enter Warehouse Title"
                                        />
                                    </Form.Group>

                                    {/* Address Input */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>Address</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="address"
                                            value={warehouseDetails.address}
                                            onChange={handleChange}
                                            placeholder="Enter Warehouse Address"
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="switch"
                                            id="active-switch"
                                            name="active"
                                            label="Active"
                                            checked={warehouseDetails.active}
                                            onChange={handleActiveChange}
                                        />
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseAddModal}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={handlesubmit}>
                                    Save
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Edit Modal */}
                        <Modal show={showEditModal} onHide={handleCloseEditModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Edit Badge</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="title"
                                            value={warehouseDetails.title}
                                            onChange={handleChange}
                                            placeholder="Enter Warehouse Title"
                                        />
                                    </Form.Group>

                                    {/* Address Input */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>Address</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="address"
                                            value={warehouseDetails.address}
                                            onChange={handleChange}
                                            placeholder="Enter Warehouse Address"
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="switch"
                                            id="active-switch"
                                            name="active"
                                            label="Active"
                                            checked={warehouseDetails.active}
                                            onChange={handleActiveChange}
                                        />
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseEditModal}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={handleSaveChanges}>
                                    Save Changes
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Delete Confirmation Modal */}
                        <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Delete Badge</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to delete this badge?
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={handleDelete}>
                                    Delete
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>

                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default Warehouses